import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable, interval, Subject, BehaviorSubject } from 'rxjs';
import { switchMap, catchError, timeout } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrinterService {
  private apiUrl =  `${environment.zebraUrl}/print`;
  private printerName = 'ZEBRA_PRINTERS';
  private printerStatusSubject = new Subject<any>();
  constructor(private http: HttpClient) { }

  // Método para verificar o status da impressora
  checkPrinterStatus(): Observable<string> {
    // Verificar se o usuário está logado
    const token = localStorage.getItem('jwt') || localStorage.getItem('jwt-password');
    if (!token) {
      console.warn('Tentativa de verificar status da impressora sem autenticação. Usuário não está logado.');
      return of('{"status": "error", "message": "Usuário não autenticado"}');
    }

    let _printerName = localStorage.getItem('printerName') ?? this.printerName;
    return this.http.get(`${this.apiUrl}?printerName=${_printerName}`, { responseType: 'text' }).pipe(
      catchError(error => {
        console.error('Erro ao verificar o status da impressora:', error);
        // Retorna um valor padrão ou uma string de erro
        return of('{"status": "error", "message": "Falha ao verificar status da impressora"}');
      })
    );
  }
  
  startMonitoring(): Observable<any> {
    return interval(5000).pipe(
      switchMap(() => this.checkPrinterStatus()),
      switchMap(status => {
        try {
          let obj = JSON.parse(status);
          this.printerStatusSubject.next(obj);
          return new Observable(observer => observer.next(obj));
        } catch (error) {
          console.error('Erro ao processar status da impressora:', error);
          // Retorna um Observable vazio ou um valor padrão em caso de erro
          return of({ status: 'error', message: 'Erro ao processar o status da impressora' });
        }
      }),
      catchError(error => {
        console.error('Erro no monitoramento:', error);
        // Continua o monitoramento retornando um valor padrão
        return of({ status: 'error', message: 'Erro no monitoramento da impressora' });
      })
    );
  }

  setPrinterStatus(printerStatus: any): any {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('printerStatus', printerStatus);
    }
  }

  getPrinterStatus(): any {
    if (typeof window !== 'undefined' && window.localStorage) {
      let printerStatus = localStorage.getItem('printerStatus');
      if (printerStatus)
        return JSON.parse(printerStatus);
      else
        return { status: false, message: "Falha na comunicação com a impressora" };
    }
  }

  getPrinterStatusListener(): Observable<string> {
    return this.printerStatusSubject.asObservable();
  }
}
